(function () {
    try {
        // Create and initialize a payment form object
        var paymentForm = new SqPaymentForm({

            // Initialize the payment form elements
            applicationId: window.squareInfo.app,
            locationId: window.squareInfo.loc,
            inputClass: 'sq-input',

            // Customize the CSS for SqPaymentForm iframe elements
            inputStyles: [{
                fontSize: '.9em',
                padding: '10px 0.75em',
            }],

            // Initialize the credit card placeholders
            cardNumber: {
                elementId: 'sq-card-number',
                placeholder: '•••• •••• •••• ••••'
            },
            cvv: {
                elementId: 'sq-cvv',
                placeholder: 'CVV'
            },
            expirationDate: {
                elementId: 'sq-expiration-date',
                placeholder: 'MM/YY'
            },
            postalCode: false,

            // SqPaymentForm callback functions
            callbacks: {

                /*
                 * callback function: cardNonceResponseReceived
                 * Triggered when: SqPaymentForm completes a card nonce request
                 */
                cardNonceResponseReceived: function(errors, nonce, cardData, billingContact, shippingContact) {
                    if (errors) {
                        // Clear errors.
                        var errorBox = $(".alert-error-list");
                        errorBox.html("");

                        // Add to box.
                        errors.forEach(function(error) {
                            var errMsg = document.createElement("strong");
                            errMsg.innerText = error.message;

                            errorBox.append(errMsg);
                        });

                        // Show box.
                        errorBox.parent().show();

                        updateSubmitButton(false);
                        return;
                    }

                    // Assign the nonce value to the hidden form field
                    document.getElementById('card-nonce').value = nonce;

                    // POST the nonce form to the payment processing page
                    document.getElementById('nonce-form').submit();

                },

                /*
                 * callback function: unsupportedBrowserDetected
                 * Triggered when: the page loads and an unsupported browser is detected
                 */
                unsupportedBrowserDetected: function() {
                    alert("This browser is not supported :(, please try using the latest version of Chrome or Firefox.");
                },

                /*
                 * callback function: inputEventReceived
                 * Triggered when: visitors interact with SqPaymentForm iframe elements.
                 */
                inputEventReceived: function(inputEvent) {
                    switch (inputEvent.eventType) {
                        case 'focusClassAdded':
                            /* HANDLE AS DESIRED */
                            break;
                        case 'focusClassRemoved':
                            /* HANDLE AS DESIRED */
                            break;
                        case 'errorClassAdded':
                            /* HANDLE AS DESIRED */
                            break;
                        case 'errorClassRemoved':
                            /* HANDLE AS DESIRED */
                            break;
                        case 'cardBrandChanged':
                            /* HANDLE AS DESIRED */
                            break;
                    }
                }
            }
        });

        $(".btn-submit-payment").click(function(event) {
            // Don't submit the form until SqPaymentForm returns with a nonce
            event.preventDefault();

            // Start loading.
            updateSubmitButton(true);

            // Request a nonce from the SqPaymentForm object
            paymentForm.requestCardNonce();
        });

        function updateSubmitButton(loading) {
            if (loading) {
                $(".btn-submit-payment").html('<i class="fas fa-spinner fa-spin"></i> Please Wait').attr("disabled", "disabled");
            } else {
                $(".btn-submit-payment").html("Update Payment Information").removeAttr("disabled");
            }
        }
    } catch (e) {
        // Ignore...
    }
})();